import type { QueryClient } from "@tanstack/react-query";
import {
	ApiCallError,
	handleResponseError,
} from "web_myplann/Infrastructure/Api/ApiUtils";
import { device } from "web_myplann/Utils/device";

const SESSION_EXPIRED_COOLDOWN_MS = 15_000;

let sessionExpiredReportedAt = 0;

const reportSessionExpiredToNative = () => {
	if (!window.ReactNativeWebView) {
		return false;
	}

	const now = Date.now();
	if (now - sessionExpiredReportedAt >= SESSION_EXPIRED_COOLDOWN_MS) {
		sessionExpiredReportedAt = now;
		device.sessionExpired().catch(() => undefined);
	}

	return true;
};

export function handleMyPlannResponseError(
	error: unknown,
	_queryClient: QueryClient,
) {
	if (
		error instanceof ApiCallError &&
		error.data.status === 401 &&
		reportSessionExpiredToNative()
	) {
		return;
	}

	handleResponseError(error);
}
